{
  "auditLogs": {
    "title": "Audit-Protokolle",
    "description": "Alle Datenänderungen über Mandanten-Entitäten anzeigen",
    "timestamp": "Zeitstempel",
    "actor": "Akteur",
    "action": "Aktion",
    "entityType": "Entitätstyp",
    "entityId": "Entitäts-ID",
    "summary": "Zusammenfassung",
    "scope": "Bereich",
    "superadminScope": "Superadmin",
    "filterByThisActor": "Nach diesem Akteur filtern",
    "filterByThisEntity": "Nach diesem Entitätstyp filtern",
    "filterByThisEntityId": "Nach dieser Entitäts-ID filtern",
    "fieldChanges": "Feldänderungen",
    "batchInfo": "Batch-Info",
    "snapshot": "Dokument-Snapshot",
    "empty": "Keine Audit-Protokolle gefunden",
    "showing": "Zeige {{from}}-{{to}} von {{total}}",
    "previous": "Zurück",
    "next": "Weiter",
    "systemActor": "System",
    "ip": "IP",
    "endpoint": "Endpunkt",
    "sessionId": "Sitzungs-ID",
    "actionCreate": "Erstellen",
    "actionUpdate": "Aktualisieren",
    "actionSoftDelete": "Vorläufig löschen",
    "actionDestroy": "Endgültig löschen",
    "actionBulkSoftDelete": "Massen-Soft-Delete",
    "actionBulkDestroy": "Massen-Löschung",
    "actionBulkWrite": "Massenschreiben",
    "field": "Feld",
    "from": "Von",
    "to": "Zu",
    "batchFilter": "Filter",
    "batchUpdate": "Aktualisierung",
    "batchMatched": "Übereinstimmend",
    "batchModified": "Geändert",
    "noDetails": "Keine Details verfügbar",
    "fieldsChanged": "{{count}} Feld(er) geändert",
    "matchedModified": "{{matched}} übereinstimmend, {{modified}} geändert",
    "snapshotCaptured": "Snapshot erfasst"
  },
  "tenantAdmin": {
    "title": "Mandanten",
    "description": "Alle Mandanten im System verwalten",
    "createTenant": "Mandant erstellen",
    "editTenant": "Mandant bearbeiten",
    "updateTenant": "Mandant aktualisieren",
    "createDescription": "Einen neuen Mandanten zum System hinzufügen",
    "cloneTenant": "Mandant duplizieren",
    "cloneDescription": "Eine unabhängige Kopie von {{name}} erstellen, einschließlich aller Daten.",
    "cloneNameDefault": "Kopie von {{name}}",
    "cloneWarningTitle": "Benutzer werden mitkopiert",
    "cloneWarning": "Der Klon kopiert alle Benutzer mit ihren bestehenden Zugangsdaten. Jeder Benutzer kann sich mit derselben E-Mail und demselben Passwort in beiden Mandanten anmelden.",
    "cloneStarted": "Die Duplizierung läuft im Hintergrund. Der neue Mandant wird aktiv, sobald sie abgeschlossen ist.",
    "cloneRunningBadge": "wird erstellt…",
    "cloneRunningTooltip": "Duplizierung läuft im Hintergrund: {{phase}}",
    "clonePhaseCopying": "Daten werden kopiert",
    "clonePhaseProvisioning": "Zugänge werden eingerichtet",
    "clonePhaseImporting": "Demo-Anmeldungen werden importiert",
    "cloneInterruptedBadge": "Duplizierung unterbrochen",
    "cloneFailedBadge": "Duplizierung fehlgeschlagen",
    "cloneImportFailedBadge": "Demo-Logins fehlen",
    "cloneImportFailed": "Der Mandant wurde dupliziert und ist einsatzbereit, aber die Demo-Logins konnten nicht eingerichtet werden. Bis der Import erneut läuft, kann sich niemand anmelden.",
    "cloneCompletedBadge": "Hinweis übrig",
    "cloneCompleted": "Die Duplizierung ist abgeschlossen und der Mandant ist einsatzbereit. Nur dieser Hinweis konnte nicht automatisch entfernt werden — ihn auszublenden ist unbedenklich.",
    "cloneInterruptedAlertTitle": "Duplizierung von {{name}} unterbrochen",
    "cloneInterruptedAlert": "Die Duplizierung wurde unterbrochen und nicht abgeschlossen. Es wurde nichts gelöscht: Der unvollständige Mandant ({{slug}}) existiert weiterhin und ist inaktiv. „Verwerfen und löschen“ entfernt ihn samt Datenbank und Mitgliedschaften, „Ignorieren“ behält ihn und blendet nur diesen Hinweis aus.",
    "cloneFailedAlertTitle": "Duplizierung von {{name}} fehlgeschlagen",
    "cloneFailedAlert": "Die Duplizierung ist fehlgeschlagen und wurde zurückgesetzt. Was vom unvollständigen Mandanten ({{slug}}) übrig ist, ist inaktiv. „Verwerfen und löschen“ entfernt die Reste samt Datenbank und Mitgliedschaften, „Ignorieren“ behält sie und blendet nur diesen Hinweis aus.",
    "cloneDiscardPartialAlertTitle": "Verwerfen von {{name}} unvollständig",
    "cloneDiscardPartialAlert": "Das Verwerfen wurde bereits ausgeführt und ist nur teilweise gelungen. Fehlgeschlagen: {{steps}}. Alles Übrige wurde entfernt.",
    "cloneDiscardPartialRetry": "Mandant und Datenbank sind noch vorhanden — das Verwerfen kann erneut ausgeführt werden.",
    "cloneDiscardPartialManual": "Mandant und Datenbank sind bereits entfernt; die oben genannten Reste müssen von Hand beseitigt werden. „Ignorieren“ blendet nur diesen Hinweis aus.",
    "cloneCleanupStepRevokeMemberships": "Mitgliedschaften entziehen",
    "cloneCleanupStepDeactivateZitadelOrg": "Zitadel-Organisation deaktivieren",
    "cloneCleanupStepDropDatabase": "Datenbank löschen",
    "cloneCleanupStepDeleteTenantRow": "Mandanteneintrag löschen",
    "cloneDiscard": "Verwerfen und löschen",
    "cloneDismiss": "Ignorieren",
    "cloneDiscardTitle": "Unvollständige Kopie verwerfen",
    "cloneDiscardDescription": "Der Mandant {{name}}, seine Datenbank und alle dabei angelegten Mitgliedschaften werden endgültig gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
    "cloneDiscardSuccess": "Unvollständige Kopie verworfen",
    "cloneDiscardPartial": "Die Kopie konnte nur teilweise entfernt werden. Der Hinweis bleibt bestehen, bis die Reste beseitigt sind.",
    "cloneDismissSuccess": "Hinweis ausgeblendet",
    "cloneFailed": "Mandant konnte nicht dupliziert werden",
    "editDescription": "Die Mandanteninformationen aktualisieren",
    "searchPlaceholder": "Mandanten suchen...",
    "tenantName": "Mandantenname",
    "tenantNamePlaceholder": "Mandantenname eingeben",
    "tenantNameRequired": "Mandantenname ist erforderlich",
    "tenantSlug": "Mandanten-Slug",
    "tenantSlugPlaceholder": "mandanten-slug",
    "tenantSlugRequired": "Mandanten-Slug ist erforderlich",
    "tenantSlugPattern": "Slug darf nur Kleinbuchstaben, Zahlen und Bindestriche enthalten",
    "tenantSlugHelper": "URL-freundlicher Bezeichner (automatisch aus dem Namen generiert)",
    "tenantType": "Mandantentyp",
    "tenantTypePlaceholder": "Mandantentyp auswählen",
    "tenantTypeCustomer": "Kunde",
    "tenantTypePartner": "Partner",
    "expirationDate": "Ablaufdatum",
    "expirationHelper": "Leer lassen für kein Ablaufdatum",
    "cancel": "Abbrechen",
    "createFailed": "Mandant konnte nicht erstellt werden",
    "updateFailed": "Mandant konnte nicht aktualisiert werden",
    "columnName": "Name",
    "columnSlug": "Slug",
    "columnType": "Typ",
    "columnAccount": "Konto",
    "accountLabel": "Konto: {{name}}",
    "noAccount": "Kein Konto",
    "columnStatus": "Status",
    "columnExpires": "Läuft ab",
    "columnMembers": "Mitglieder",
    "columnProcesses": "Prozesse",
    "filterAll": "Alle",
    "statusActive": "Aktiv",
    "statusInactive": "Inaktiv",
    "expiresNever": "Nie",
    "hideExpired": "Abgelaufene ausblenden",
    "deleteSuccess": "Mandant erfolgreich gelöscht",
    "deleteFailed": "Mandant konnte nicht gelöscht werden",
    "deleteTitle": "Mandant löschen",
    "deleteDescription": "Bist du sicher, dass du diesen Mandanten löschen möchtest? Dies löscht auch alle zugehörigen Daten. Diese Aktion kann nicht rückgängig gemacht werden.",
    "deleteConfirmInstruction": "Gib <strong /> ein, um das Löschen zu bestätigen.",
    "deleteConfirmPlaceholder": "Mandantenname eingeben zur Bestätigung",
    "cloneWarningDemoTitle": "Demo: neue Zugangsdaten werden erstellt",
    "cloneWarningDemo": "Der Klon kopiert alle Benutzer, aber jede E-Mail wird auf eine frische Demo-Adresse umgeschrieben (z. B. demo+max.muster.12@bliks.io) und alle Benutzer erhalten das unten gesetzte Demo-Passwort. Benutzer früherer Demos haben so keinen Zugriff auf diese Demo.",
    "tenantTypeDemo": "Demo",
    "tenantDescription": "Anmerkung",
    "tenantDescriptionPlaceholder": "z. B. Demo für Firma XYZ",
    "columnDescription": "Anmerkung",
    "demoPassword": "Demo-Passwort",
    "demoPasswordRequired": "Demo-Passwort erforderlich: mindestens 8 Zeichen mit Groß-, Kleinbuchstaben und Ziffer",
    "demoPasswordHint": "Gemeinsames Passwort für alle Benutzer dieser Demo. Mindestens 8 Zeichen, mit Groß-, Kleinbuchstaben und Ziffer.",
    "homeOrgLabel": "Heimatorganisation",
    "homeOrgNotSet": "Nicht festgelegt",
    "homeOrgMoveWarningTitle": "Anmeldekonto wird neu erstellt",
    "homeOrgMoveWarning": "Wenn du diese Person in eine andere Heimatorganisation verschiebst, wird ihr Anmeldekonto neu erstellt. Passwort, Passkeys und MFA gehen verloren, aktive Sitzungen können sich bis zum Abschluss der neuen Einladung nicht erneut verifizieren, und eine neue Einladungs-E-Mail wird versendet.",
    "homeOrgNoTargets": "Diese Person ist in keiner SSO-Organisation Mitglied, die als Heimatorganisation gesetzt werden kann.",
    "homeOrgDeletedBadge": "Heimatorganisation gelöscht",
    "homeOrgDeletedTooltip": "Die Heimatorganisation dieser Person wurde gelöscht — die Anmeldung ist (oder wird) blockiert. Weise eine neue Heimatorganisation zu, um den Zugang wiederherzustellen.",
    "homeOrgDeletedAlertTitle": "Heimatorganisation gelöscht — Konto gesperrt",
    "homeOrgDeletedAlert": "Die Heimatorganisation dieser Person wurde gelöscht, daher ist die Anmeldung blockiert (oder wird es in Kürze). Wähle unten eine neue Heimatorganisation, um den Zugang wiederherzustellen.",
    "homeOrgDeletedNoTargetsAlert": "Die Heimatorganisation dieser Person wurde gelöscht, daher ist die Anmeldung blockiert (oder wird es in Kürze). Es gibt keine geeignete Zielorganisation — gib der Person zuerst eine Mitgliedschaft in einer SSO-Organisation und weise diese anschließend als neue Heimatorganisation zu.",
    "hubspotCompanyId": "HubSpot Company-ID",
    "hubspotCompanyIdPlaceholder": "z. B. 340997605594",
    "hubspotPartnerCompanyIdHelper": "HubSpot-Company-ID der Partner-Firma (Typ „Partner“).",
    "cloneSource": "Vorlage",
    "cloneSourceHint": "Von diesem Arbeitsbereich werden alle Daten kopiert.",
    "cloneSourcePlaceholder": "Arbeitsbereich wählen",
    "cloneSourceRequired": "Bitte einen Arbeitsbereich als Vorlage wählen",
    "createDemo": "Demo erstellen",
    "createDemoDescription": "Eine Demo entsteht als Kopie eines bestehenden Arbeitsbereichs — sie bringt dessen Inhalte mit, aber eigene Zugangsdaten.",
    "hubspotCompanyIdHelper": "HubSpot-Company-ID dieses Kunden. Verknüpft die HubSpot-Firma mit diesem Bliks-Tenant."
  },
  "recordingAnalytics": {
    "title": "Aufnahme-Analysen",
    "description": "Durchschnittliche aktive Aufnahmezeit pro Prozess, über alle Mandanten",
    "scope": "Mandant",
    "allTenants": "Alle Mandanten",
    "empty": "Noch keine Aufnahmezeit-Daten",
    "tenant": "Mandant",
    "process": "Prozess",
    "minutesSuffix": "{{value}} Min.",
    "avgPerStep": "Ø Zeit pro Schritt",
    "avgPerProcess": "Ø Zeit pro Prozess",
    "acrossSteps": "über {{count}} Schrittaufnahmen",
    "acrossProcesses": "über {{count}} Prozesse",
    "processCount": "Prozesse",
    "stepCount": "Schritte",
    "total": "Gesamtzeit",
    "step": "Schritt",
    "stepTime": "Aufnahmezeit"
  },
  "aiUsage": {
    "title": "KI-Nutzung",
    "description": "KI-Kosten und Token-Verbrauch pro Mandant",
    "tenantTabDescription": "Gesamte KI-Kosten und Token-Verbrauch dieses Mandanten, nach Quelle und Modell",
    "scope": "Mandant",
    "allTenants": "Alle Mandanten",
    "range": "Zeitraum",
    "range7d": "Letzte 7 Tage",
    "range30d": "Letzte 30 Tage",
    "range90d": "Letzte 90 Tage",
    "rangeAll": "Gesamter Zeitraum",
    "empty": "Noch keine KI-Nutzung erfasst",
    "loadError": "KI-Nutzungsdaten konnten nicht geladen werden",
    "tenant": "Mandant",
    "totalCost": "Gesamtkosten",
    "cost": "Kosten",
    "calls": "Aufrufe",
    "callsBreakdown": "{{generation}} Generierungen · {{embedding}} Embeddings · {{transcription}} Transkriptionen",
    "acrossCalls_one": "über {{count}} Aufruf",
    "acrossCalls_other": "über {{count}} Aufrufe",
    "tokens": "Tokens",
    "tokensBreakdown": "{{input}} ein · {{output}} aus",
    "transcription": "Transkription",
    "minutesSuffix": "{{value}} Min.",
    "source": "Quelle",
    "unknownSource": "Unbekannte Quelle",
    "kind": "Typ",
    "kindFeature": "Funktion",
    "kindApp": "App",
    "model": "Modell",
    "inputTokens": "Eingabe-Tokens",
    "outputTokens": "Ausgabe-Tokens",
    "priceMissingEvents_one": "{{count}} Aufruf ohne Preiseintrag, mit Kosten 0 gezählt",
    "priceMissingEvents_other": "{{count}} Aufrufe ohne Preiseintrag, mit Kosten 0 gezählt",
    "priceMissingWarning_one": "{{count}} Aufruf ohne Preiseintrag — Kostensummen sind zu niedrig",
    "priceMissingWarning_other": "{{count}} Aufrufe ohne Preiseintrag — Kostensummen sind zu niedrig",
    "failedTenantsWarning_one": "{{count}} Mandant konnte nicht gelesen werden — Summen sind unvollständig",
    "failedTenantsWarning_other": "{{count}} Mandanten konnten nicht gelesen werden — Summen sind unvollständig"
  },
  "partnerContent": {
    "title": "Partner-Inhalte",
    "description": "Was alle Vertriebspartner sehen: Unterlagen und Videos im Info Hub sowie die Neuigkeiten auf ihrer Startseite.",
    "tabs": {
      "materials": "Info Hub",
      "news": "Neuigkeiten"
    },
    "status": {
      "published": "Veröffentlicht",
      "draft": "Entwurf"
    },
    "filter": {
      "all": "Alle"
    },
    "emptyFiltered": "Kein Eintrag passt zum Filter.",
    "columns": {
      "order": "Reihenfolge",
      "title": "Titel",
      "status": "Status",
      "languages": "Sprachen",
      "updatedAt": "Geändert",
      "publishedAt": "Veröffentlicht am"
    },
    "actions": {
      "publish": "Veröffentlichen",
      "unpublish": "Zurückziehen",
      "saveDraft": "Als Entwurf speichern",
      "undo": "Rückgängig",
      "moveUp": "Nach oben",
      "moveDown": "Nach unten"
    },
    "toast": {
      "published": "Veröffentlicht. Partner sehen es jetzt.",
      "saved": "Als Entwurf gespeichert.",
      "saveFailed": "Speichern fehlgeschlagen. Bitte noch einmal versuchen."
    },
    "completeness": {
      "complete": "vollständig",
      "partial": "unvollständig",
      "empty": "fehlt"
    },
    "languages": {
      "title": "Sprachen",
      "contentTitle": "Inhalt je Sprache",
      "hint": "Deutsch ist Pflicht. Fehlt eine Sprache, sehen Partner die englische Fassung, sonst die deutsche.",
      "present": "{{language}} vorhanden",
      "missing": "{{language}} fehlt"
    },
    "fields": {
      "titleIn": "Titel ({{language}})",
      "descriptionIn": "Beschreibung ({{language}})"
    },
    "materials": {
      "add": "Unterlage anlegen",
      "createTitle": "Neue Unterlage",
      "editTitle": "Unterlage bearbeiten",
      "dialogDescription": "Erscheint im Info Hub aller Partner, sobald sie veröffentlicht ist.",
      "general": "Allgemein",
      "kind": "Art",
      "kinds": {
        "file": "Datei",
        "video": "Video"
      },
      "kindHints": {
        "file": "PDF, PowerPoint, Word oder Excel, je Sprache eine Datei",
        "video": "Ein YouTube-Video"
      },
      "videoUrl": "YouTube-Link",
      "videoPreview": "Vorschaubild des Videos",
      "needsFile": "Zum Veröffentlichen braucht die Unterlage mindestens eine Datei.",
      "empty": "Noch keine Unterlagen. Legen Sie die erste an.",
      "loadError": "Die Unterlagen konnten nicht geladen werden.",
      "deleteEntityPhrase": "diese Unterlage samt ihrer Dateien",
      "files": {
        "label": "Datei",
        "dropTitle": "Datei auf {{language}} hierher ziehen",
        "dropHint": "PDF, PowerPoint, Word oder Excel, bis 25 MB",
        "choose": "Datei auf {{language}} auswählen",
        "replace": "Ersetzen",
        "remove": "Datei auf {{language}} entfernen",
        "uploadOnSave": "wird beim Speichern hochgeladen",
        "removedOnSave": "{{name}} wird beim Speichern entfernt.",
        "rejected": {
          "format": "Erlaubt sind PDF, PowerPoint, Word und Excel.",
          "size": "Die Datei ist größer als 25 MB."
        }
      }
    },
    "news": {
      "add": "Neuigkeit schreiben",
      "createTitle": "Neue Neuigkeit",
      "editTitle": "Neuigkeit bearbeiten",
      "dialogDescription": "Erscheint auf der Startseite der Partner, sobald sie veröffentlicht ist; die Zielgruppe entscheidet, bei welchen.",
      "general": "Allgemein",
      "pinned": "Zuerst zeigen",
      "pin": "Zuerst zeigen",
      "unpin": "Nicht mehr zuerst zeigen",
      "bodyIn": "Text ({{language}})",
      "preview": "Vorschau",
      "previewHint": "So sehen Partner die Neuigkeit auf {{language}}.",
      "empty": "Noch keine Neuigkeiten. Schreiben Sie die erste.",
      "loadError": "Die Neuigkeiten konnten nicht geladen werden.",
      "deleteEntityPhrase": "diese Neuigkeit",
      "eyebrow": "Kicker",
      "eyebrowIn": "Kicker ({{language}})",
      "footnoteIn": "Fußnote ({{language}})",
      "links": "Buttons",
      "primaryAction": "Hauptbutton",
      "secondaryAction": "Nebenbutton",
      "actionLabelIn": "Beschriftung {{action}} ({{language}})",
      "images": {
        "title": "Bilder",
        "logo": "Logo",
        "logoHint": "Erscheint oben, z. B. OMR und G2 in einem Bild. PNG, JPG, WebP oder SVG, bis 2 MB.",
        "image": "Bild",
        "imageHint": "Erscheint quadratisch neben dem Text. PNG, JPG, WebP oder SVG, bis 2 MB.",
        "choose": "{{label}} auswählen",
        "remove": "{{label}} entfernen",
        "rejected": {
          "format": "Erlaubt sind PNG, JPG, WebP und SVG.",
          "size": "Das Bild ist größer als 2 MB."
        }
      },
      "audience": "Zielgruppe",
      "audienceHint": "Für alle Partner, oder nur für Partner, die die Sales-App nutzen.",
      "audienceAll": "Alle Partner",
      "audienceSales": "Nutzer der Sales-App"
    }
  },
  "accountAdmin": {
    "addAccount": "Konto anlegen",
    "addAccountHint": "Company suchen, die zum Kunden wird — zugeordnet wird die HubSpot-ID.",
    "addTenant": "Arbeitsbereich anlegen",
    "assignCompany": "Company zuordnen",
    "assignCompanyHint": "Nach Name oder Domain suchen — zugeordnet wird immer die HubSpot-ID, nie der Name.",
    "backToAccounts": "Zurück zu den Konten",
    "changeCompany": "Company ändern",
    "childCount": "{{count}} untergeordnet",
    "children": "Untergeordnete Konten",
    "columnGroup": "Gruppe",
    "columnName": "Kunde",
    "columnTenants": "Arbeitsbereiche",
    "companiesUnavailable": "Firmennamen konnten nicht aus HubSpot geladen werden — die Konten sind vollständig, nur die Namen fehlen.",
    "company": {
      "ambiguous": {
        "primary": "Mehrere Kontakte tragen „Hauptansprechpartner\". Der erste gilt — bitte im CRM eindeutig machen.",
        "billing": "Mehrere Kontakte tragen „Abrechnungskontakt\". Der erste gilt — bitte im CRM eindeutig machen."
      },
      "billingContactRole": "Rechnung",
      "contactUnnamed": "Kontakt ohne Namen",
      "heading": "Firma im CRM",
      "noAddress": "Keine Anschrift im CRM gepflegt",
      "noBillingContact": "Kein Abrechnungskontakt im CRM gekennzeichnet",
      "noBillingEmail": "Kein Rechnungsempfänger gepflegt",
      "noContact": "Kein Hauptansprechpartner im CRM gekennzeichnet",
      "noVatId": "Keine USt-IdNr. gepflegt",
      "primaryContactRole": "Angebot",
      "refresh": "Aus HubSpot aktualisieren",
      "refreshChanged": "Stammdaten aus HubSpot übernommen.",
      "refreshUnchanged": "HubSpot gelesen — nichts Neues.",
      "refreshUnread": "HubSpot war nicht lesbar. Der zuletzt gelesene Stand gilt weiter.",
      "unknownName": "Name unbekannt",
      "unlinked": "Noch keine Firma verknüpft",
      "vatConfirmed": "bestätigt",
      "vatRejected": "nicht bestätigt",
      "vatUnchecked": "ungeprüft"
    },
    "companyTaken": "Bereits zugeordnet",
    "createCompany": "„{{name}}\" in HubSpot anlegen",
    "createWithoutCompany": "Ohne Company anlegen",
    "description": "Die Kunden — je Rechtsperson ein Konto, das mehrere Arbeitsbereiche tragen kann.",
    "detachParent": "Lösen",
    "empty": "Noch keine Konten angelegt.",
    "group": "Gruppe",
    "groupHint": "Konten lassen sich unter einem Dach bündeln — Konzern, Kette, Verbund. Die Zuordnung erteilt für sich genommen keine Rechte: kein Lesen über Mitglieder, keine geteilte Lizenz, keine geerbte Zahlungsart.",
    "noChildren": "Diesem Konto ist keines untergeordnet.",
    "noCompany": "Keine HubSpot-Company hinterlegt",
    "noParent": "Keinem Konto zugeordnet",
    "notFound": "Konto nicht gefunden.",
    "openIn": "In {{system}} öffnen",
    "parent": "Übergeordnetes Konto",
    "partOf": "Gehört zu",
    "saved": "Gespeichert.",
    "searchCompanyEmpty": "Keine Company gefunden.",
    "searchCompanyMin": "Mindestens drei Zeichen eingeben.",
    "searchCompanyPlaceholder": "Name oder Domain …",
    "searching": "Wird gesucht …",
    "tenants": "Arbeitsbereiche",
    "title": "Konten",
    "unnamed": "Ohne Namen"
  }
}
